import { AxiosResponse } from "axios";
import Axios, { Response } from "../utils/Axios";
import { RequestOrderProudctType } from "../recoil/type";
import { getRecoil } from "recoil-nexus";
import { authState } from "../recoil/auth";

const ApiController = {
  store: {
    setPause: async (store_id: number, pause: number): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/store/setPause`;

        const response: any = await Axios.post(sUrl, {
          store_id,
          pause,
        });

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "ERROR [order/setPause]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    getStoreSelector: async (masterStoreId: number): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/store/getStoreSelector";

        const response: any = await Axios.post(sUrl, {
          master_store_id: masterStoreId,
        });

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/getStoreSelector] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/getStoreSelector] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    getStoreData: async (store_id: number): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/store/getStoreData`;
        const response: AxiosResponse = await Axios.post(sUrl, { store_id });

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/getStoreData] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/getStoreData] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    getOptions: async (productId: number): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/product/getOptions`;
        const data = {
          product_id: productId,
        };
        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/getOptions] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/getOptions] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
  },

  order: {
    getStoreOrder: async (): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/order/getStoreOrderAll`;
        // const data = {
        //   order_id
        // }

        const response: any = await Axios.post(sUrl);

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "ERROR [order/getStoreOrderAll]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    getStoreOrderComplete: async (): Promise<Response> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + `/order/getStoreOrderComplete`;
        // const data = {
        //   order_id
        // }

        const response: any = await Axios.post(sUrl);

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "ERROR [order/getStoreOrderComplete]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    getStoreOrderNotComplete: async (): Promise<Response> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + `/order/getStoreOrderNotComplete`;
        // const data = {
        //   order_id
        // }

        const response: any = await Axios.post(sUrl);

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "ERROR [order/getStoreOrderNotComplete]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    getOrderByOrderId: async (order_id: string): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/order/getOrderByOrderId`;
        const data = {
          order_id,
        };

        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "ERROR [order/getOrderByOrderId]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    getOrderDevice: async (): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/order/getOrderDevice`;
        const data = {
          user_token_id: getRecoil(authState).user_token_id,
        };

        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "ERROR [order/getOrderDevice]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    products: async (data: RequestOrderProudctType): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/order/products";

        const response: AxiosResponse = await Axios.post(sUrl, data);

        // if(getResponseValidation(response)){
        return response.data;
        // }else{
        //   return {
        //     ok: false,
        //     msg: "ERROR [order/products] : ",
        //     data: undefined,
        //     status: 500,
        //   };
        // }
      } catch (err: any) {
        console.error("ERROR [order/products] : ", err);

        return {
          ok: false,
          msg: "ERROR [order/products] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    // delivery_type 변경
    updateDeliveryType: async (oParams: any): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/order/updateDeliveryType`;

        const response: any = await Axios.post(sUrl, oParams);

        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[updateDeliveryType error]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
  },

  auth: {
    signin: async (params: any): Promise<any> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/auth/signin`;
        const response: any = await Axios.post(sUrl, params);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[로그인 오류]" + err.toString(),
          data: undefined,
        };
      }
    },

    getStoreList: async (user_id: number): Promise<any> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/auth/getStoreList`;
        const response = await Axios.post(sUrl, { user_id });
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[getStoreList error]" + err.toString(),
          data: undefined,
        };
      }
    },
  },

  delivery: {
    statusCheckNCall: async (oParams: any): Promise<any> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/delivery/statusCheckNCall`;
        const response = await Axios.post(sUrl, oParams);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[statusCheckNCall error]" + err.toString(),
          data: undefined,
        };
      }
    },
    cancel: async (oParams: any): Promise<any> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/delivery/cancel`;
        const response = await Axios.post(sUrl, oParams);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[cancel error]" + err.toString(),
          data: undefined,
        };
      }
    },

    // 바로고 등록 여부 확인
    checkAlreadyRegisteredStore: async (oParams: any): Promise<Response> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL +
          `/delivery/checkAlreadyRegisteredStore`;

        const response: any = await Axios.post(sUrl, oParams);

        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[checkAlreadyRegisteredStore error]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
  },
};

const getResponseValidation = (res: AxiosResponse) => {
  if (res.status === 200) {
    const response: Response = res.data.data;

    if (response.ok) {
      return true;
    } else {
      return false;
    }
  }

  return false;
};

export default ApiController;
